module.exports = __webpack_public_path__ + "static/media/check_active.18c07b7a.svg";